// mirrors EventSource#readyState
export const ESS_CONNECTING = "CONNECTING";
export const ESS_OPEN = "OPEN";
export const ESS_CLOSED = "CLOSED";
// our own custom states
export const ESS_CONNECT_FATAL = "CONNECT_FATAL";

export const createEventServiceStatusStore = (set, get, api, setIn) => ({
	status: null,
	lastConnectedUnixSec: null,

	setStatus: (status) => {
		const nextState = { status };
		if (status === ESS_OPEN) {
			nextState.lastConnectedUnixSec = Math.floor(Date.now() / 1000);
		}
		setIn(nextState);
	},
});
